import React from 'react'

const Profile = () => {
  return (
    <div style={{marginTop:"80px"}}>Profile</div>
  )
}

export default Profile